import { render } from "./result.vue?vue&type=template&id=4aa6bf8c"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=4aa6bf8c&lang=less"
script.render = render

export default script